import {HubApiRequest} from '../hub-api-request';
import {TokenVerifyReq, TokenVerifyResponse} from '../protocol/token-verify-req';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';

export class TokenVerify extends HubApiRequest<TokenVerifyReq, TokenVerifyResponse> {
    constructor(url: string, data: TokenVerifyReq) {
        super(url, HubMethod.TOKEN_VERIFY, null, data, uuidv4());
    }
}
